import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  ArrowLeftEndOnRectangleIcon,
  ArrowRightStartOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Servizi', href: '/servizi' },
  { name: 'Contatti', href: '/contatti' },
  { name: 'Calcola', href: '/dashboard' },
];

const Header = props => {
  const { pathname } = props;
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white">
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
      >
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">NCC Bro driver</span>
            <img alt="" src="/img/LOGO-1.svg" className="h-8 w-auto dark:hidden" />
            <img alt="" src="/img/LOGO-1.svg" className="hidden h-8 w-auto dark:block" />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map(item => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-sm/6 font-semibold text-gray-900 ${
                item.href === pathname ? 'underline decoration-2 underline-offset-4' : ''
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          {user ? (
            <Link to="/logout" aria-label="Logout" title="Logout">
              <ArrowRightStartOnRectangleIcon className="size-6 text-gray-900 hover:text-primary" />
            </Link>
          ) : (
            <Link to="/login" aria-label="Login" title="Login">
              <ArrowLeftEndOnRectangleIcon className="size-6 text-gray-900 hover:text-primary" />
            </Link>
          )}
        </div>
      </nav>
      <div className="max-w-full border-t border-primary" />
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">NCC Bro driver</span>
              <img alt="" src="/img/LOGO-1.svg" className="h-8 w-auto dark:hidden" />
              <img alt="" src="/img/LOGO-1.svg" className="hidden h-8 w-auto dark:block" />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map(item => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              <div className="py-6">
                {user ? (
                  <a
                    href="/logout"
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                    aria-label="Logout"
                    title="Logout"
                  >
                    <ArrowRightStartOnRectangleIcon className="size-6" />
                  </a>
                ) : (
                  <a
                    href="/login"
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                    aria-label="Login"
                    title="Login"
                  >
                    <ArrowLeftEndOnRectangleIcon className="size-6" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
};

export default Header;
